import { Auth } from "aws-amplify";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export function Logout() {
  const navigate = useNavigate();

  const signout = async () => {
    await Auth.signOut();
    navigate("/");
  };

  useEffect(() => {
    signout();
  }, []);

  return (
    <div>
      <p>logging out...</p>
    </div>
  );
}
